<template>
  <div>
    <div class="text-center primary--text">
      <div class="d-flex flex-column justify-space-between align-center">
        <v-img aspect-ratio="1"  width="100%"  max-width="200px" contain src="@/assets/Hand.svg"></v-img>
        <h1 class="display-1 ma-5 font-weight-bold white--text">{{ $t('app_headline') }}</h1>
      </div>
      <div class="my-2">A warm welcome to the Greeting Platform of the Conference of the World Council of Religious Leaders on Faith and Diplomacy: Generations in Dialogue!
      </div>
      <div class="my-2">
        Here you can record brief personal video messages with warm greetings, directing them towards other assembly participants or humanity as a whole. This tool will allow us to be and stay connected to participants from all around the world. Choose one topic you want to talk about and record a video of 30 seconds.
      </div>
      <div class="my-2">
        Please be informed that the video messages will be collected by the organizers. By clicking on the START Button, you agree that the organizers of the assembly are allowed to use your video message to promote the work of Religions for Peace and Ring for Peace.
      </div>
      <div class="my-2 font-italic">
        Thank you for your understanding and support. We are looking forward to seeing your message!
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex';

export default {
  name: 'StepIntro',
  components: {},
  data: () => ({}),
  // ...
  computed: {
    ...mapState({})
  },
  methods: {}
}
</script>
